export default __webpack_public_path__ + "static/char-16-aeeca1a93722f14f2da75f4e53ce5589.webp";